export type Digits = 'fa' | 'latn';

const FA = '۰۱۲۳۴۵۶۷۸۹';
const AR = '٠١٢٣٤٥٦٧٨٩';

/** Convert any Latin/Arabic-Indic digits in a string to Persian digits. */
export function toPersianDigits(input: string | number): string {
  return String(input).replace(/[0-9]/g, (d) => FA[+d]!).replace(/[٠-٩]/g, (d) => FA[AR.indexOf(d)]!);
}

/** Convert Persian/Arabic-Indic digits to Latin digits (for parsing user input). */
export function toLatinDigits(input: string): string {
  return input.replace(/[۰-۹]/g, (d) => String(FA.indexOf(d))).replace(/[٠-٩]/g, (d) => String(AR.indexOf(d)));
}

/** Apply the requested digit system to an already formatted string. */
export function withDigits(s: string, digits: Digits): string {
  return digits === 'fa' ? toPersianDigits(s) : toLatinDigits(s);
}

/** BCP-47 numbering-system extension for Intl. */
export const nu = (digits: Digits) => (digits === 'fa' ? 'arabext' : 'latn');
